import { css, keyframes, SerializedStyles } from '@emotion/core';
import theme from '../../styles/theme';

const spinner: SerializedStyles = keyframes`
  to {transform: rotate(360deg) }
`;

const fadein: SerializedStyles = keyframes`
  from { opacity: 0}
  to { opacity: 1}
`;

const root = css`
  animation: ${spinner} 1.6s infinite linear;
  border-bottom-color: #777; /*TODO: it should be declared in theme, discussion with DESIGN needed */
  border-left-color: #777; /*TODO: it should be declared in theme, discussion with DESIGN needed */
  border-radius: 50%;
  border-right-color: ${theme.colors.white};
  border-top-color: ${theme.colors.white};
`;

export default {
  spinner,
  fadein,
  root,
};
